package com.pincer.app.viewmodel

import com.pincer.app.ApplicationState
import com.pincer.app.I18n
import com.pincer.core.model.tree.Answer
import com.pincer.core.model.tree.Participant
import com.pincer.core.model.tree.QuestionFormat
import com.pincer.core.model.tree.CHATS_SCOPE
import com.pincer.core.model.tree.PERMISSIONS_SCOPE
import com.pincer.core.model.tree.QUESTIONS_SCOPE
import com.pincer.core.model.tree.CANDIDATES_SCOPE
import com.pincer.core.model.tree.SELECTED_SCOPE
import com.pincer.core.model.tree.NAME_SCOPE
import com.pincer.core.model.tree.DESCRIPTION_SCOPE
import com.pincer.core.model.tree.RULES_SCOPE
import com.pincer.core.model.tree.PARTICIPANTS_SCOPE
import com.pincer.core.model.tree.PARTICIPANTS_ANSWERS_SCOPE
import com.pincer.core.model.tree.PARTICIPANTS_RULES_SCOPE
import com.pincer.core.model.tree.PARTICIPANTS_ROLES_SCOPE
import com.pincer.core.model.drafts.QuestionDraft
import com.pincer.core.model.drafts.AnswerDraft
import com.pincer.core.functions.termsNeeded
import com.pincer.core.functions.getAnswer
import com.pincer.core.functions.readable
import com.pincer.core.functions.readablePid
import com.pincer.core.functions.getRolesForParticipant
import com.pincer.core.functions.validateText
import com.pincer.core.functions.validateEmail
import com.pincer.core.functions.validateCode
import com.pincer.core.functions.validateQuestionCode
import com.pincer.core.functions.validateRegex
import com.pincer.core.functions.validateRoles
import com.pincer.core.functions.validateRole
import com.pincer.core.functions.validateOptions
import com.pincer.core.functions.validateAnswer
import com.pincer.core.functions.validateRules

fun pincerDetail(state: ApplicationState, context: Node) {
    if (state.transient.pid == null) return

    val name =
        if (!state.pincerIsReady() || state.pincer()?.name.isNullOrBlank() || !state.checkRead(NAME_SCOPE))
            readable(state.transient.pid!!)
        else
            state.pincer()!!.name!!

    context.node("pincer", wording = name) {
        if (!state.pincerIsReady()) {
            loading("loading")
        }
        else {

            if (state.pincer()!!.description != null && state.checkRead(DESCRIPTION_SCOPE)) {
                node(key="description", wording=state.pincer()!!.description!!)
            }

            missingCredentials(state, this)

            pincerTakePart(state, this)

            pincerQuestions(state, this)

            pincerSettings(state, this)
        }
    }
}